/* eslint-disable @typescript-eslint/no-require-imports */
import CustomPlatform from "$src/core/utils/platform/platform";

import type { TVFocusViewProps } from "./types";

export default CustomPlatform.select<() => React.FC<TVFocusViewProps>>({
  tv: () => require("./TVFocusGuideView.tv").default,
  default: () => require("./TVFocusGuideView").default,
})();
